/**
 * Downgrade deferral to the next billing cycle applies only after the hotel's first
 * invoice has been paid. Until then, the open invoice can be updated in place.
 */
export function shouldConfirmDowngradeNextCycle({ isDowngrade, isFirstPaymentMade }) {
  return !!isDowngrade && !!isFirstPaymentMade
}

export function shouldLockDowngradeToNextCycle({ feeNotExceeding, isFirstPaymentMade }) {
  return !!feeNotExceeding && !!isFirstPaymentMade
}
